var jade = require("/Users/nmd/dev/vsct.info/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (style) {
buf.push("<div class=\"row\"><div class=\"small-12 columns\"><table class=\"custom_table\"><tbody><tr v-repeat=\"data.table.tbody\" v-if=\"$value\"><td" + (jade.cls([style.td], [true])) + ">{{* data.table.thead[$key] }}</td><td>{{ $value }}</td></tr></tbody></table><a v-link=\"{name: 'profile/edit'}\" v-if=\"data.table\"" + (jade.cls(['button',style.btn], [null,true])) + ">Заявка на изменение данных</a><component is=\"alert\" data-name=\"{{ name }}\" data-message=\"{{ data.message }}\"></component></div></div>");}.call(this,"style" in locals_for_with?locals_for_with.style:typeof style!=="undefined"?style:undefined));;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/profile/info/template.jade
 ** module id = 118
 ** module chunks = 0
 **/